import { render } from "./Appointment2View.vue?vue&type=template&id=2ae3c282&ts=true"
import script from "./Appointment2View.vue?vue&type=script&lang=ts"
export * from "./Appointment2View.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__